import VueCookies from 'vue-cookies';

const cookieStore = {
  cookieStore: {}, // Temporary in-memory store

  getCookie(name) {
    // Fetch from browser cookies
    let browserValue = VueCookies.get(name);
    if (browserValue == 'null') { browserValue = null; }

    // Fallback to temporary store if the browser value is stale
    if (
      this.cookieStore.hasOwnProperty(name) &&
      this.cookieStore[name] !== browserValue
    ) {
      console.warn(
        `Cookie "${name}" has a stale browser value. Using temporary store value.`
      );
      return this.cookieStore[name];
    }

    const returnValue = browserValue || null;
    console.log(`Returning "${name}" = "${returnValue}`);
    return returnValue;
  },

  setCookie(name, value, expires = 86400) {
    console.log(`Setting cookie "${name}" = "${value}" (expires in ${expires} seconds)`);

    // Set cookie in browser
    VueCookies.set(name, value, expires, '/');

    // Update the temporary store
    this.cookieStore[name] = value;
  },

  syncCookieStore(name) {
    // Synchronize a specific cookie to the temporary store
    const browserValue = VueCookies.get(name);

    if (browserValue !== undefined) {
      console.log(
        `Syncing cookie "${name}" from browser (${browserValue}) to temporary store.`
      );
      this.cookieStore[name] = browserValue;
    }
  },

  init() {
    if (typeof window !== 'undefined') {
      // Only run on the client
      const allCookies = VueCookies.keys();
      allCookies.forEach((key) => {
        this.cookieStore[key] = VueCookies.get(key);
      });
      console.log('Initialized cookie store:', this.cookieStore);
    }
  },

  created() {
    cookieStore.init(); // Safe to call here, only runs on the client
  },  
};

export const cookies = {
    created() {
      cookieStore.init(); // Initialize store when used as a mixin
    },
    methods: {
      getCookie: cookieStore.getCookie.bind(cookieStore),
      setCookie: cookieStore.setCookie.bind(cookieStore),
      syncCookieStore: cookieStore.syncCookieStore.bind(cookieStore),
    },
  };
  
export default cookieStore;
